import { hexStringToBuffer } from '@iotize/common/byte-converter';
import { KaitaiStreamWriter } from '@iotize/common/byte-stream';
import { HashType } from '@iotize/common/crypto';
import { algo, enc, lib, LibWordArray, WordArray } from 'crypto-js';

export class CryptoHelper {
  public static sanitizeInput(
    input: Uint8Array | string | LibWordArray,
  ): string | LibWordArray {
    if (input instanceof Uint8Array) {
      return CryptoHelper.byteArrayToWordArray(input);
    } else {
      return input;
    }
  }

  public static byteArrayToWordArray(ba: Uint8Array): LibWordArray {
    const wa: number[] = [];
    for (let i = 0; i < ba.length; i++) {
      wa[(i / 4) | 0] |= ba[i] << (24 - 8 * i);
    }
    const result = lib.WordArray.create(wa);
    result.sigBytes = ba.length;
    return result;
  }

  public static getAlgoImpl(type: HashType): any {
    switch (type) {
      case 'sha1':
        return algo.SHA1;
      case 'sha256':
        return algo.SHA256;
      default:
        throw new Error('Unknown algo type: ' + type);
    }
  }

  public static wordToByteArray(word: number, length: number): Uint8Array {
    const ba = [];
    if (length > 0) ba.push(word >>> 24);
    if (length > 1) ba.push((word >>> 16) & 0xff);
    if (length > 2) ba.push((word >>> 8) & 0xff);
    if (length > 3) ba.push(word & 0xff);
    return Uint8Array.from(ba);
  }

  public static libWordArrayToByteArray(
    libWordArray: LibWordArray,
    length?: number,
  ): Uint8Array {
    if (!length) {
      length = libWordArray.sigBytes;
    }
    const wordArray = libWordArray.words;

    const result = [];
    let i = 0;
    while (length > 0) {
      const bytes = CryptoHelper.wordToByteArray(
        wordArray[i],
        Math.min(4, length),
      );
      length -= bytes.length;
      result.push(bytes);
      i++;
    }
    return KaitaiStreamWriter.mergeArrays(...result);
  }

  static wordArrayToByteArray(input: WordArray): Uint8Array {
    return hexStringToBuffer(input.toString(enc.Hex));
  }
}
